export default __webpack_public_path__ + "static/media/emblem_dark.24a73c5a.svg";